<payarc-section-card heading="Bank Accounts">
  <div scard-action class="bal-actions">
    <button type="button" payarcButton="secondary" (click)="openHistory()">History</button>
    <button type="button" payarcButton="primary" (click)="changeBankAccount()">Change Bank Account</button>
  </div>

  <div class="pa-table-wrap">
    <payarc-table>
      <thead>
        <tr>
          <th [attr.aria-sort]="ariaSort(sortDirection('account_number'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('account_number')">Account <payarc-sort-icon [direction]="sortDirection('account_number')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('routing_number'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('routing_number')">Routing Number <payarc-sort-icon [direction]="sortDirection('routing_number')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('used_for'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('used_for')">Used For <payarc-sort-icon [direction]="sortDirection('used_for')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('status'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('status')">Status <payarc-sort-icon [direction]="sortDirection('status')"></payarc-sort-icon></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3]">
            <td *ngFor="let c of [1,2,3,4]"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <tr *ngIf="!loadFlag && errorMsg">
          <td class="pa-table__state-cell" colspan="4">
            <payarc-empty-state title="No bank accounts found" [message]="errorMsg"></payarc-empty-state>
          </td>
        </tr>

        <ng-container *ngIf="!loadFlag && !errorMsg && bankAccountList.data.length > 0">
          <tr *ngFor="let reject of bankAccountList.data">
            <td class="strong" [innerHTML]="highlight(reject.bank_account_number)"></td>
            <td class="muted" [innerHTML]="highlight(reject.routing_number)"></td>
            <td class="muted" [innerHTML]="highlight(reject.used_for)"></td>
            <td><payarc-status-badge [status]="reject.status"></payarc-status-badge></td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>
  </div>

  <div class="bal-pager-row" *ngIf="!errorMsg && bankAccountList?.data?.length > 0">
    <label class="bal-pager-row__limit">
      Rows per page
      <select class="pa-input" [(ngModel)]="limit" (change)="limitChange()">
        <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
      </select>
    </label>
    <payarc-pager
      [rangeLabel]="pagerRangeLabel"
      [pages]="pagerPages"
      [currentPage]="currentPage"
      [disablePrev]="currentPage <= 1"
      [disableNext]="currentPage >= totalPages"
      (prev)="pagerPrev()"
      (next)="pagerNext()"
      (pageSelect)="pagerSelect($event)"
    ></payarc-pager>
  </div>
</payarc-section-card>
